module.exports = __webpack_public_path__ + "static/media/banner_3.28977c86.jpg";